import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";

import { SubmitQuestionMenu } from "components/SubmitQuestionMenu";
import { ClientAppEvent } from "constants/index";

import { QuoteQADisplay } from "../QuoteQADisplay";

interface Props {
  error: string | null;
  loading: boolean;
  renderSubmitQuestion: boolean;
  qaList: QuoteQA[];
  quote: CondensedQuote;
}

export function QuoteQA(props: Props) {
  const { error, loading, renderSubmitQuestion, qaList, quote } = props;
  const posthog = usePostHog();

  // Mirrors the capture in QuoteQAModal, the other place a shipper can ask about
  // a quote, so one series counts both entry points.
  const handleQuestionSubmitted = () => {
    posthog?.capture(ClientAppEvent.QUOTE_QUESTION_ASKED, {
      quote_id: quote.quote,
      shipment_id: quote.shipment,
    });
  };

  if (loading) {
    return (
      <Stack alignItems="center" sx={{ mt: "1rem" }}>
        <CircularProgress />
      </Stack>
    );
  }
  if (error != null) {
    return (
      <Stack>
        <Typography color="red" align="center">
          {error}
        </Typography>
      </Stack>
    );
  }

  const submitQuestionProps = {
    render: quote != null && quote !== undefined,
    textFieldLabel: "Ask the carrier a question",
    postURL: `/quotes/${quote.quote}/questions`,
    addPadding: false,
    onQuestionSubmitted: handleQuestionSubmitted,
  };

  if (!qaList || qaList.length < 1) {
    return (
      <Stack>
        {renderSubmitQuestion && (
          <Box>
            <SubmitQuestionMenu {...submitQuestionProps} />
          </Box>
        )}
        <Typography mt=".5rem" align="center">
          No questions have been asked for this quote.
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack
      id="quote-qa-column"
      direction="column"
      justifyContent="space-between"
    >
      {renderSubmitQuestion && (
        <Box>
          <SubmitQuestionMenu {...submitQuestionProps} />
        </Box>
      )}
      <Stack spacing={1} pt="1rem">
        {qaList.map((quoteQA) => (
          <Box key={quoteQA.question.id}>
            <QuoteQADisplay qa={quoteQA} shipmentId={quote.shipment} />
          </Box>
        ))}
      </Stack>
    </Stack>
  );
}
